/* CS PDP hero + buy box: keuzeblok (selling plans), garantie-dialog,
   gallery-thumbs, mini review-carrousel en sticky bars. */
(() => {
  /* De theme editor voert sectiescripts opnieuw uit bij elke re-render;
     zonder guard stapelen de document-listeners zich op. */
  if (window.__csPdpHeroInit) return;
  window.__csPdpHeroInit = true;

  const initPdp = (section) => {
    const root = section.querySelector('[data-cs-pdp]');
    if (!root || root.dataset.csInit === '1') return;
    root.dataset.csInit = '1';
    const teardowns = [];

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* ---------- Keuzeblok: pakketselectie gebonden aan Juo selling plans ---------- */
    const pakketten = Array.from(root.querySelectorAll('[data-cs-pakket]'));
    const qtyInput = root.querySelector('[data-cs-qty]');
    const planInput = root.querySelector('[data-cs-plan]');
    const ctaPrijs = root.querySelector('[data-cs-cta-prijs]');
    const ctaRegel1 = root.querySelector('[data-cs-cta-regel1]');
    const ctaRegel2 = root.querySelector('[data-cs-cta-regel2]');
    const microLijst = root.querySelector('[data-cs-micro]');
    /* Beide sticky bars (desktop en mobiel) volgen de pakketkeuze. */
    const stickyPrijs = Array.from(root.querySelectorAll('[data-cs-sticky-prijs]'));
    const stickyOud = Array.from(root.querySelectorAll('[data-cs-sticky-oud]'));
    const stickySub = Array.from(root.querySelectorAll('[data-cs-sticky-sub]'));
    const stickyLabel = Array.from(root.querySelectorAll('[data-cs-sticky-label]'));

    /* Microregels horen bij de keuze: bij eenmalig gaat het over bedenktijd,
       bij een abonnement over doorlopen en stoppen. De regels komen als platte
       tekst uit het data-attribuut, dus textContent — nooit innerHTML. */
    const zetMicroRegels = (tekst) => {
      if (!microLijst) return;
      const regels = (tekst || '')
        .split('\n')
        .map((r) => r.trim())
        .filter(Boolean);
      microLijst.textContent = '';
      regels.forEach((regel) => {
        const li = document.createElement('li');
        li.className = 'cs-pdp__micro-regel';
        li.innerHTML =
          '<svg class="cs-pdp__micro-vink" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6L9 17l-5-5"/></svg>';
        const span = document.createElement('span');
        span.textContent = regel;
        li.appendChild(span);
        microLijst.appendChild(li);
      });
    };


    /* Pakket-specifieke hoofdafbeelding: pakket met eigen beeld wisselt de
       grote productfoto (toon wat je krijgt), zonder beeld → standaardbeeld
       terug. Thumb-actiefstaat volgt mee naar de hero-thumb. */
    let standaardBeeld = null;
    /* Vergelijken zonder querystring: de server rendert hetzelfde beeld op
       een andere CDN-breedte; dat is geen wissel. */
    const beeldBasis = (url) => (url || '').split('?')[0];
    const zetHoofdbeeld = (pakket) => {
      const img = root.querySelector('[data-cs-main]');
      if (!img) return;
      /* De eerste thumbnail hoort hetzelfde beeld te tonen als slide 1. */
      const eersteThumb = root.querySelector('[data-cs-thumb]');
      const eersteThumbImg = eersteThumb ? eersteThumb.querySelector('img') : null;
      if (!standaardBeeld) {
        standaardBeeld = {
          src: img.dataset.stdSrc || img.getAttribute('src'),
          srcset: img.dataset.stdSrcset || img.getAttribute('srcset') || '',
          alt: img.getAttribute('alt') || '',
          thumb: eersteThumbImg ? eersteThumbImg.getAttribute('src') : '',
          thumbSrc: eersteThumb ? eersteThumb.dataset.src : '',
          thumbSrcset: eersteThumb ? eersteThumb.dataset.srcset : '',
        };
      }
      const doel = pakket.dataset.beeldSrc
        ? {
            src: pakket.dataset.beeldSrc,
            srcset: pakket.dataset.beeldSrcset || '',
            alt: pakket.dataset.beeldAlt || standaardBeeld.alt,
            thumb: pakket.dataset.beeldThumb || pakket.dataset.beeldSrc,
            thumbSrc: pakket.dataset.beeldSrc,
            thumbSrcset: pakket.dataset.beeldSrcset || '',
          }
        : standaardBeeld;
      if (beeldBasis(img.getAttribute('src')) === beeldBasis(doel.src)) return;
      img.src = doel.src;
      if (doel.srcset) {
        img.setAttribute('srcset', doel.srcset);
      } else {
        img.removeAttribute('srcset');
      }
      img.alt = doel.alt;

      /* Thumbnail 1 volgt het pakket, inclusief de bron die een klik erop
         terugzet als hoofdbeeld. */
      if (eersteThumbImg && doel.thumb) eersteThumbImg.src = doel.thumb;
      if (eersteThumb) {
        if (doel.thumbSrc) eersteThumb.dataset.src = doel.thumbSrc;
        if (doel.thumbSrcset) {
          eersteThumb.dataset.srcset = doel.thumbSrcset;
        } else {
          delete eersteThumb.dataset.srcset;
        }
        eersteThumb.dataset.alt = doel.alt;
      }

      root.querySelectorAll('[data-cs-thumb]').forEach((t, i) => {
        t.classList.toggle('is-active', i === 0);
        if (i === 0) {
          t.setAttribute('aria-current', 'true');
        } else {
          t.removeAttribute('aria-current');
        }
      });
      /* De thumbnailrij scrollt mee terug naar het begin: mobiel passen er maar
         vier vakjes naast elkaar, dus anders blijft de rij staan bij een beeld
         dat niet meer actief is. Inline en niet via toonThumb: die staat
         verderop in dit bestand en bestaat nog niet wanneer de init-sync het
         standaardpakket kiest. */
      const spoorTerug = root.querySelector('[data-cs-thumbs]');
      if (spoorTerug) spoorTerug.scrollTo({ left: 0, behavior: 'smooth' });


      /* Mobiel: terug naar slide 1, anders kijkt de bezoeker nog naar een
         ander beeld terwijl het pakket net gewisseld is. */
      const mediaEl = root.querySelector('[data-cs-media]');
      if (mediaEl && mediaEl.scrollLeft > 0) mediaEl.scrollTo({ left: 0, behavior: 'smooth' });
    };

    const kiesPakket = (pakket) => {
      pakketten.forEach((p) => p.classList.toggle('is-selected', p === pakket));
      zetHoofdbeeld(pakket);
      if (qtyInput) qtyInput.value = pakket.dataset.quantity || '1';
      if (planInput) {
        const plan = pakket.dataset.sellingPlan || '';
        planInput.value = plan;
        planInput.disabled = plan === '';
      }
      if (ctaPrijs) ctaPrijs.textContent = pakket.dataset.prijs || '';
      /* Knop van twee regels: actie boven, bedrag (plus frequentie) onder.
         Eén actie houdt dezelfde naam in de zwevende balk. */
      const regel1 = pakket.dataset.cta1 || '';
      /* Regel 2 is optioneel (ontwerp 1-9-2026: alleen "In winkelwagen →");
         leeg blijft leeg, de CSS verbergt de lege regel. */
      const regel2 = pakket.dataset.cta2 || '';
      if (ctaRegel1) ctaRegel1.textContent = regel1;
      if (ctaRegel2) ctaRegel2.textContent = regel2;

      zetMicroRegels(pakket.dataset.micro);

      /* Sticky bars: korte pakketnaam, oude en nieuwe prijs, en op desktop de
         regel "1 verpakking · 30 nachten" (30 nachten per verpakking). */
      const kort = pakket.dataset.titelKort || pakket.dataset.titel || '';
      const nachten = (parseInt(pakket.dataset.quantity, 10) || 1) * 30;
      stickyPrijs.forEach((el) => (el.textContent = pakket.dataset.prijs || ''));
      stickyOud.forEach((el) => {
        el.textContent = pakket.dataset.oudePrijs || '';
        el.hidden = !pakket.dataset.oudePrijs;
      });
      stickyLabel.forEach((el) => (el.textContent = kort));
      stickySub.forEach((el) => (el.textContent = `${kort} · ${nachten} nachten`));
    };
    root.csKiesPakket = kiesPakket;

    pakketten.forEach((pakket) => {
      const radio = pakket.querySelector('.cs-pakket__radio');
      if (!radio) return;
      radio.addEventListener('change', () => {
        if (radio.checked) kiesPakket(pakket);
      });
    });

    /* ---------- ATC: fetch + cart drawer i.p.v. redirect naar /cart ----------
       Zonder drawer (sectie verwijderd of JS nog niet geladen) submit het
       formulier native en redirect Shopify zelf naar de cart-pagina. */
    const form = root.querySelector('[data-cs-form]');
    if (form) {
      form.addEventListener('submit', (event) => {
        if (!window.CSCart || !document.querySelector('[data-cs-cart-drawer]')) return;
        event.preventDefault();
        const submitKnop = event.submitter || form.querySelector('[data-cs-cta]');
        if (submitKnop) {
          submitKnop.disabled = true;
          submitKnop.classList.add('is-toevoegen');
        }
        window.CSCart
          .addAndOpen(new FormData(form), submitKnop)
          .finally(() => {
            if (submitKnop) {
              submitKnop.disabled = false;
              submitKnop.classList.remove('is-toevoegen');
            }
          });
      });
    }

    /* Init-sync met de echte radiostand: bij formulierherstel (reload of
       terugnavigatie zonder bfcache) kan de checked radio afwijken van de
       server-gerenderde default; zonder sync gaan hidden inputs en UI uiteen. */
    const checkedRadio = root.querySelector('.cs-pakket__radio:checked');
    if (checkedRadio) {
      const actief = checkedRadio.closest('[data-cs-pakket]');
      if (actief) kiesPakket(actief);
    }

    /* Pakket-beelden alvast ophalen (idle) zodat de wissel zonder flits gaat. */
    const prefetchPakketBeelden = () => {
      pakketten.forEach((p) => {
        if (!p.dataset.beeldSrc) return;
        const im = new Image();
        if (p.dataset.beeldSrcset) {
          im.srcset = p.dataset.beeldSrcset;
          im.sizes = '(min-width: 990px) 534px, calc(100vw - 36px)';
        }
        im.src = p.dataset.beeldSrc;
      });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchPakketBeelden, { timeout: 3000 });
    } else {
      setTimeout(prefetchPakketBeelden, 1500);
    }

    /* ---------- Gallery ----------
       Desktop: thumbnails wisselen het hoofdbeeld (één zichtbaar beeld).
       Mobiel: alle beelden staan naast elkaar in een scroll-snap carrousel;
       een thumbnail scrollt ernaartoe en swipen markeert de juiste thumbnail. */
    const mainImg = root.querySelector('[data-cs-main]');
    const media = root.querySelector('[data-cs-media]');
    const thumbs = Array.from(root.querySelectorAll('[data-cs-thumb]'));
    const desktopGallery = window.matchMedia('(min-width: 990px)');

    const thumbSpoor = root.querySelector('[data-cs-thumbs]');
    const thumbNavs = Array.from(root.querySelectorAll('[data-cs-thumbnav]'));

    /* Het spoor loopt op beide breakpoints horizontaal, maar de as komt uit de
       CSS in plaats van uit een breakpoint hier: zet een layout de vakjes ooit
       onder elkaar, dan volgen scrollen en pijlen vanzelf mee. */
    const spoorVerticaal = () =>
      !!thumbSpoor && getComputedStyle(thumbSpoor).flexDirection === 'column';

    const spoorMaat = () => {
      if (!thumbSpoor) return { teScrollen: 0, positie: 0 };
      return spoorVerticaal()
        ? {
            teScrollen: thumbSpoor.scrollHeight - thumbSpoor.clientHeight,
            positie: thumbSpoor.scrollTop,
          }
        : {
            teScrollen: thumbSpoor.scrollWidth - thumbSpoor.clientWidth,
            positie: thumbSpoor.scrollLeft,
          };
    };

    /* Een pijl staat er alleen als je die kant op kunt: aan het begin van de
       rij dus geen pijl naar links. Hij verdwijnt helemaal (hidden) in plaats
       van onzichtbaar te worden, zodat de vakjes bij het laden gewoon links
       uitlijnen met het hoofdbeeld. De rij wordt daardoor 36px breder of
       smaller op de twee uiteinden; dat gebeurt tijdens het scrollen zelf.
       Verbergen maakt de rij alleen breder en dus teScrollen kleiner, nooit
       groter, dus dit kan niet heen en weer blijven schakelen. */
    const werkThumbNavBij = () => {
      if (!thumbSpoor || !thumbNavs.length) return;
      const { teScrollen, positie } = spoorMaat();
      const nodig = teScrollen > 4;
      thumbNavs.forEach((knop) => {
        const richting = Number(knop.dataset.csThumbnav) || 1;
        const opEinde = richting < 0 ? positie <= 2 : positie >= teScrollen - 2;
        knop.hidden = !nodig || opEinde;
      });
    };

    /* De actieve thumbnail in beeld houden zonder de pagina te verspringen:
       alleen binnen het spoor zelf scrollen, langs de as die actief is. Staat
       het spoor niet in beeld (offsetParent leeg), dan valt er niets in beeld
       te houden en zou een scrollBy alleen maar werk zijn. */
    const toonThumb = (thumb) => {
      if (!thumbSpoor || !thumb || thumbSpoor.offsetParent === null) return;

      const spoor = thumbSpoor.getBoundingClientRect();
      const doel = thumb.getBoundingClientRect();
      const marge = 12;
      if (spoorVerticaal()) {
        if (doel.top < spoor.top + marge) {
          thumbSpoor.scrollBy({ top: doel.top - spoor.top - marge });
        } else if (doel.bottom > spoor.bottom - marge) {
          thumbSpoor.scrollBy({ top: doel.bottom - spoor.bottom + marge });
        }
        return;
      }
      if (doel.left < spoor.left + marge) {
        thumbSpoor.scrollBy({ left: doel.left - spoor.left - marge });
      } else if (doel.right > spoor.right - marge) {
        thumbSpoor.scrollBy({ left: doel.right - spoor.right + marge });
      }
    };

    /* volgSpoor uit tijdens het swipen: markeren mag elke frame, maar de
       thumbnailrij bijscrollen niet. Een tweede scrollanimatie naast de
       lopende snap-animatie brak die in Chromium af (zie eigenScroll verderop);
       de rij schuift daarom pas mee zodra de carrousel stilstaat. */
    const markeerThumb = (index, volgSpoor = true) => {
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        if (i === index) {
          t.setAttribute('aria-current', 'true');
        } else {
          t.removeAttribute('aria-current');
        }
      });
      if (volgSpoor) toonThumb(thumbs[index]);
    };


    thumbNavs.forEach((knop) => {
      knop.addEventListener('click', () => {
        if (!thumbSpoor) return;
        const richting = Number(knop.dataset.csThumbnav) || 1;
        /* Eén "pagina" thumbnails per klik, met een beetje overlap. */
        const verticaal = spoorVerticaal();
        const stap =
          (verticaal ? thumbSpoor.clientHeight : thumbSpoor.clientWidth) - 40;
        thumbSpoor.scrollBy(
          verticaal ? { top: richting * stap } : { left: richting * stap }
        );
      });
    });

    if (thumbSpoor) {
      thumbSpoor.addEventListener('scroll', werkThumbNavBij, { passive: true });
      window.addEventListener('resize', werkThumbNavBij);
      werkThumbNavBij();
      /* Beelden laden lazy; als ze binnenkomen verandert de scrollbreedte. */
      if ('ResizeObserver' in window) {
        new ResizeObserver(werkThumbNavBij).observe(thumbSpoor);
      }
    }

    /* Zolang wij zelf scrollen negeert de scroll-listener zijn werk. Anders
       leest hij halverwege de animatie een tussenpositie en scrollt hij het
       thumbspoor bij, wat de lopende animatie in Chromium afbreekt: de
       carrousel bleef dan één slide verderop hangen. */
    let eigenScroll = 0;

    /* Eén weg naar een beeld: gebruikt door de thumbnails, de bolletjes, door
       slepen op het hoofdbeeld (desktop) en door de pijltoetsen. */
    const toonBeeld = (index) => {
      const doel = Math.max(0, Math.min(index, thumbs.length - 1));
      const thumb = thumbs[doel];
      if (!thumb) return;
      if (desktopGallery.matches) {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.src;
        if (thumb.dataset.srcset) {
          mainImg.setAttribute('srcset', thumb.dataset.srcset);
        } else {
          mainImg.removeAttribute('srcset');
        }
        mainImg.alt = thumb.dataset.alt || '';
      } else if (media) {
        const slide = media.children[doel];
        if (slide) {
          clearTimeout(eigenScroll);
          eigenScroll = setTimeout(() => {
            eigenScroll = 0;
          }, 300);
          /* Direct positioneren, niet smooth: met scroll-snap-type x mandatory
             breekt Chromium een smooth programmatische scroll meteen af en
             blijft de carrousel op zijn plek staan. Swipen zelf houdt gewoon
             de vloeiende animatie van de browser. */
          media.scrollLeft = slide.offsetLeft - media.offsetLeft;
        }
      }

      markeerThumb(doel);
    };


    const huidigeIndex = () => Math.max(0, thumbs.findIndex((t) => t.classList.contains('is-active')));

    /* De rij schuift niet onder je vandaan bij een tik: toonBeeld scrolt hem
       net genoeg om de gekozen thumbnail te laten zien, zodat de buren blijven
       staan en je ziet wáár in de reeks je zit. Eerder sprong de aangetikte
       naar de kop van de rij; dan verspringt bij elke keuze de hele rij. */
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => toonBeeld(index));
    });


    /* Slepen op het hoofdbeeld (desktop): mobiel heeft al native scroll-snap.
       Alleen bij een duidelijk horizontale beweging, zodat verticaal scrollen
       en het slepen van de afbeelding zelf niet in de weg zitten. */
    if (media) {
      let startX = 0;
      let startY = 0;
      let sleept = false;
      const DREMPEL = 45;

      media.addEventListener('pointerdown', (e) => {
        if (!desktopGallery.matches || e.pointerType === 'touch' || e.button !== 0) return;
        sleept = true;
        startX = e.clientX;
        startY = e.clientY;
        media.classList.add('is-sleept');
      });

      const beeindig = (e) => {
        if (!sleept) return;
        sleept = false;
        media.classList.remove('is-sleept');
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (Math.abs(dx) < DREMPEL || Math.abs(dx) < Math.abs(dy)) return;
        toonBeeld(huidigeIndex() + (dx < 0 ? 1 : -1));
      };

      media.addEventListener('pointerup', beeindig);
      media.addEventListener('pointercancel', () => {
        sleept = false;
        media.classList.remove('is-sleept');
      });
      media.addEventListener('pointerleave', beeindig);
      /* Voorkomt dat de browser het beeld als bestand oppakt tijdens het slepen. */
      media.addEventListener('dragstart', (e) => {
        if (desktopGallery.matches) e.preventDefault();
      });
    }

    /* Swipen op mobiel markeert de thumbnail die bij het zichtbare beeld hoort
       en scrollt die in beeld. Dat gebeurde eerst 80ms nádat het scrollen
       ophield; opgeteld bij de snap-animatie liep de markering een halve
       seconde achter op haar duim. Nu volgt hij de scrollpositie live, één
       update per frame. */
    if (media) {
      let scrollRaf = 0;
      let laatsteIndex = -1;

      const volgScroll = () => {
        scrollRaf = 0;
        if (desktopGallery.matches) return;
        /* Stap = slidebreedte plus de gap, niet de spoorbreedte: de slides
           zijn smaller dan het spoor zodat de volgende al in beeld steekt. */
        const eerste = media.firstElementChild;
        const stap = eerste ? eerste.offsetWidth + 8 : media.clientWidth;
        if (!stap) return;
        /* Afronden op de dichtstbijzijnde slide: de markering springt over
           zodra je voorbij de helft bent, precies waar de snap ook heen gaat. */
        const index = Math.min(
          Math.round(media.scrollLeft / stap),
          thumbs.length - 1
        );
        if (index === laatsteIndex) return;
        laatsteIndex = index;
        /* Bij een tik op een thumbnail is die al gemarkeerd door toonBeeld; dan
           alleen bijhouden waar we staan, anders raakt de teller uit de pas
           zodra ze daarna weer swipet. */
        if (eigenScroll) return;
        markeerThumb(index, false);
      };


      /* Zodra het swipen stilvalt schuift de thumbnailrij naar het beeld waar
         ze op uitkwam. Mobiel passen er maar vier vakjes naast elkaar, dus
         zonder dit staat de actieve thumbnail al snel buiten beeld. */
      let rust = 0;

      media.addEventListener(
        'scroll',
        () => {
          if (!scrollRaf) scrollRaf = requestAnimationFrame(volgScroll);
          clearTimeout(rust);
          rust = setTimeout(() => {
            rust = 0;
            if (desktopGallery.matches || eigenScroll) return;
            toonThumb(thumbs[laatsteIndex]);
          }, 140);
        },
        { passive: true }
      );
      teardowns.push(() => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        clearTimeout(rust);
        clearTimeout(eigenScroll);
      });
    }



    /* ---------- Bezorgteller ----------
       Echte urgentie op een echte deadline: de tijd tot de cutoff plus de dag
       waarop het pakket dan in de bus ligt. Geen kunstmatige schaarste, dus
       ook geen teller die morgen opnieuw begint.

       Alles rekent in Europe/Amsterdam, niet in de tijdzone van het toestel:
       een bezoeker in Spanje ziet anders een uur te veel. */
    const lever = root.querySelector('[data-cs-lever]');
    if (lever && !lever.hasAttribute('data-teller-uit')) {
      const leverTekst = lever.querySelector('[data-cs-lever-tekst]');
      const sjabloon = lever.dataset.sjabloon || '';
      const dagen = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
      /* Instelling telt 1 = maandag ... 7 = zondag; JS telt 0 = zondag. */
      const bezorgdagen = new Set(
        (lever.dataset.bezorgdagen || '2,3,4,5,6,7')
          .split(',')
          .map((d) => Number(d.trim()) % 7)
          .filter((d) => !Number.isNaN(d))
      );
      const [cutoffUur, cutoffMin] = (lever.dataset.cutoff || '23:59')
        .split(':')
        .map((n) => parseInt(n, 10));

      const nuInNl = () => {
        /* en-CA geeft YYYY-MM-DD, dus een string die Date betrouwbaar leest. */
        const fmt = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Amsterdam',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false,
        });
        const d = {};
        fmt.formatToParts(new Date()).forEach((p) => (d[p.type] = p.value));
        /* hour kan '24' zijn bij middernacht in sommige runtimes. */
        const uur = d.hour === '24' ? '00' : d.hour;
        return new Date(`${d.year}-${d.month}-${d.day}T${uur}:${d.minute}:${d.second}`);
      };

      const werkTellerBij = () => {
        if (!leverTekst || !sjabloon || !bezorgdagen.size) return false;
        const nu = nuInNl();
        if (Number.isNaN(nu.getTime())) return false;
        const cutoff = new Date(nu);
        cutoff.setHours(cutoffUur, cutoffMin, 0, 0);
        /* Na de cutoff is de belofte van vandaag verlopen; dan valt de teller
           terug op de statische leverregel in plaats van te liegen. */
        const resterend = cutoff - nu;
        if (resterend <= 0) return false;

        /* Bezorgdag = de eerstvolgende dag waarop bezorgd wordt. */
        const bezorg = new Date(nu);
        for (let i = 1; i <= 7; i += 1) {
          bezorg.setDate(nu.getDate() + i);
          if (bezorgdagen.has(bezorg.getDay())) break;
        }

        const uren = Math.floor(resterend / 3600000);
        const minuten = Math.floor((resterend % 3600000) / 60000);
        let tijd;
        if (uren > 0) {
          tijd = `${uren} uur en ${minuten} ${minuten === 1 ? 'minuut' : 'minuten'}`;
        } else {
          tijd = `${minuten} ${minuten === 1 ? 'minuut' : 'minuten'}`;
        }

        leverTekst.textContent = sjabloon
          .replace('{tijd}', tijd)
          .replace('{dag}', dagen[bezorg.getDay()]);
        return true;
      };

      if (werkTellerBij()) {
        /* Eén tik per minuut is genoeg: de tekst noemt minuten, geen seconden. */
        const tik = setInterval(() => {
          if (!werkTellerBij()) clearInterval(tik);
        }, 60000);
        teardowns.push(() => clearInterval(tik));
      }
    }

    /* ---------- Mini-FAQ: hoogstens één open ---------- */
    const uitleg = root.querySelector('[data-cs-uitleg]');
    if (uitleg) {
      const items = Array.from(uitleg.querySelectorAll('.cs-uitleg__item'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((ander) => {
            if (ander !== item) ander.open = false;
          });
        });
      });
    }

    /* ---------- Mini review-carrousel ---------- */

    const reviewkaart = root.querySelector('[data-cs-reviews]');
    if (reviewkaart) {
      const reviews = Array.from(reviewkaart.querySelectorAll('[data-cs-review]'));
      const dots = Array.from(reviewkaart.querySelectorAll('.cs-review__dotje'));
      let index = 0;
      const toonReview = (nieuw) => {
        index = (nieuw + reviews.length) % reviews.length;
        reviews.forEach((r, i) => (r.hidden = i !== index));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      };
      const vorige = reviewkaart.querySelector('[data-cs-review-vorige]');
      const volgende = reviewkaart.querySelector('[data-cs-review-volgende]');
      if (vorige) vorige.addEventListener('click', () => toonReview(index - 1));
      if (volgende) volgende.addEventListener('click', () => toonReview(index + 1));
      root.csSelecteerReview = (el) => {
        const i = reviews.indexOf(el);
        if (i >= 0) toonReview(i);
      };
    }

    /* ---------- Garantie: bottom sheet (mobiel) / modal 600px (desktop) ----------
       Opent alleen op een klik: uit de regel onder de CTA en uit de cart
       drawer. Nooit op een timer of exit intent. */
    const dialog = root.querySelector('[data-cs-garantie]');
    const triggers = Array.from(root.querySelectorAll('[data-cs-garantie-open]'));
    if (dialog) {
      const inner = dialog.querySelector('.cs-garantie-dialog__inner');
      const sluitKnop = dialog.querySelector('[data-cs-garantie-close]');
      const focusbaar = () =>
        Array.from(
          dialog.querySelectorAll(
            'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          )
        ).filter((el) => !el.disabled && el.offsetParent !== null);

      /* Achtergrond-scroll blokkeren zonder overflow:hidden op html (dat trekt
         de sticky header los, zie VOORTGANG sessie 1). De open dialog beslaat
         de hele viewport, dus alleen events die de dialog zélf raken
         (= backdrop/dim-zone buiten de sheet) worden geblokkeerd. */
      const preventTouchWheel = (event) => {
        if (event.target === dialog) event.preventDefault();
      };
      const onLockKeydown = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          sluitDialog('escape');
          return;
        }
        /* Focus trap: Tab mag de dialog niet uit. */
        if (event.key !== 'Tab') return;
        const els = focusbaar();
        if (!els.length) return;
        const eerste = els[0];
        const laatste = els[els.length - 1];
        if (event.shiftKey && document.activeElement === eerste) {
          event.preventDefault();
          laatste.focus();
        } else if (!event.shiftKey && document.activeElement === laatste) {
          event.preventDefault();
          eerste.focus();
        }
      };
      const setLock = (locked) => {
        const method = locked ? 'addEventListener' : 'removeEventListener';
        document[method]('touchmove', preventTouchWheel, { passive: false });
        document[method]('wheel', preventTouchWheel, { passive: false });
        document[method]('keydown', onLockKeydown);
      };

      /* Meten waar de pop-up vandaan komt en wat ze daarna doet. dataLayer als
         die er is, anders een gewoon event waar een pixel op kan luisteren. */
      const meld = (naam, detail) => {
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push(Object.assign({ event: naam }, detail));
        }
        document.dispatchEvent(new CustomEvent(naam, { detail }));
      };

      let laatsteTrigger = null;
      let laatsteBron = '';
      let aanHetSluiten = false;

      const openDialog = (bron, triggerEl) => {
        if (dialog.open) return;
        aanHetSluiten = false;
        laatsteTrigger = triggerEl || null;
        laatsteBron = bron || '';

        dialog.showModal();
        setLock(true);
        requestAnimationFrame(() => {
          dialog.classList.add('is-open');
          if (sluitKnop) sluitKnop.focus();
        });
        meld('guarantee_popup_open', { trigger: bron || 'onbekend' });
      };

      const sluitDialog = (methode) => {
        if (aanHetSluiten || !dialog.open) return;
        aanHetSluiten = true;
        const afronden = () => {
          aanHetSluiten = false;
          dialog.close();
          if (inner) inner.style.transform = '';
          /* Focus terug naar de trigger; die kan in de cart drawer zitten en
             daar inmiddels weg zijn. */
          if (laatsteTrigger && document.contains(laatsteTrigger)) laatsteTrigger.focus();
        };
        dialog.classList.remove('is-open');
        dialog.classList.remove('is-sleept');
        meld('guarantee_popup_close', { methode: methode || 'onbekend' });
        if (reducedMotion.matches) {
          afronden();
        } else {
          setTimeout(afronden, 280);
        }
      };

      triggers.forEach((knop) => {
        knop.addEventListener('click', () =>
          openDialog(knop.dataset.csGarantieBron || 'buybox', knop)
        );
      });

      /* De cart drawer staat in een andere sectie; die opent de pop-up hierlangs. */
      window.CSGarantie = {
        open: (bron, triggerEl) => openDialog(bron || 'extern', triggerEl),
      };

      dialog.querySelectorAll('[data-cs-garantie-close]').forEach((knop) => {
        knop.addEventListener('click', () =>
          sluitDialog(knop.dataset.csGarantieMethode || 'knop')
        );
      });

      /* CTA sluit en scrollt terug naar het bestelblok, niet naar de winkelwagen. */
      const dialogCta = dialog.querySelector('[data-cs-garantie-cta]');
      if (dialogCta) {
        dialogCta.addEventListener('click', () => {
          meld('guarantee_popup_cta_click', { trigger: laatsteBron });
          const uitCart = laatsteBron === 'cart-drawer';
          sluitDialog('cta');
          /* Vanuit de winkelwagen hoeft ze niet terug naar het bestelblok: ze
             heeft haar keuze al gemaakt en staat op het punt af te rekenen. */
          if (uitCart) return;
          const keuze = root.querySelector('[data-cs-keuzeblok]');
          if (!keuze) return;

          /* Na de sluitanimatie, anders scrollt de pagina onder een nog
             zichtbare backdrop door. */
          setTimeout(
            () =>
              keuze.scrollIntoView({
                behavior: reducedMotion.matches ? 'auto' : 'smooth',
                block: 'center',
              }),
            reducedMotion.matches ? 0 : 300
          );
        });
      }

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) sluitDialog('backdrop');
      });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        sluitDialog('escape');
      });
      dialog.addEventListener('close', () => setLock(false));

      /* Sheet omlaag slepen aan de handle (alleen mobiel; op desktop is de
         handle verborgen en vuurt dit dus nooit). */
      const handle = dialog.querySelector('[data-cs-garantie-handle]');
      if (handle && inner) {
        let startY = 0;
        let verschuiving = 0;
        let sleept = false;

        handle.addEventListener(
          'touchstart',
          (e) => {
            sleept = true;
            verschuiving = 0;
            startY = e.touches[0].clientY;
            dialog.classList.add('is-sleept');
          },
          { passive: true }
        );
        handle.addEventListener(
          'touchmove',
          (e) => {
            if (!sleept) return;
            verschuiving = Math.max(0, e.touches[0].clientY - startY);
            inner.style.transform = `translateY(${verschuiving}px)`;
          },
          { passive: true }
        );
        const eindigSleep = () => {
          if (!sleept) return;
          sleept = false;
          dialog.classList.remove('is-sleept');
          inner.style.transform = '';
          if (verschuiving > 90) sluitDialog('sleep');
        };
        handle.addEventListener('touchend', eindigSleep);
        handle.addEventListener('touchcancel', eindigSleep);
      }

      teardowns.push(() => {
        setLock(false);
        if (window.CSGarantie && window.CSGarantie.open) delete window.CSGarantie;
        if (dialog.open) dialog.close();
      });
    }

    /* ---------- Sticky bars: verschijnen zodra de CTA uit beeld is gescrold ----------
       Scroll-check i.p.v. IntersectionObserver: bij een sprong (anker, snelle flick)
       passeert de CTA het viewport binnen één frame en vuurt een observer niet. */
    const stickies = Array.from(root.querySelectorAll('[data-cs-sticky]'));
    const cta = root.querySelector('[data-cs-cta]');
    /* Herstel-view: de mobiele balk (data-cs-sticky-vroeg) verschijnt al zodra
       het productbeeld 120px in beeld is, precies wanneer de sticky knop van
       de herstel-intro (cs-pdp-koud-50.js) verdwijnt. Zelfde drempel daar. */
    const VROEG_INLOOP = 120;
    const buybox = root.querySelector('.cs-pdp__media') || root.querySelector('.cs-pdp__buybox');
    if (stickies.length && cta) {
      let rafId = 0;
      const updateStickies = () => {
        rafId = 0;
        const voorbij = cta.getBoundingClientRect().bottom < 0;
        const buyboxInBeeld = buybox ? buybox.getBoundingClientRect().top + VROEG_INLOOP < window.innerHeight : false;
        stickies.forEach((bar) => {
          const vroeg = bar.hasAttribute('data-cs-sticky-vroeg') && buyboxInBeeld;
          bar.classList.toggle('is-zichtbaar', voorbij || vroeg);
        });
      };
      const vraagUpdate = () => {
        if (!rafId) rafId = requestAnimationFrame(updateStickies);
      };
      window.addEventListener('scroll', vraagUpdate, { passive: true });
      window.addEventListener('resize', vraagUpdate, { passive: true });
      updateStickies();
      teardowns.push(() => {
        window.removeEventListener('scroll', vraagUpdate);
        window.removeEventListener('resize', vraagUpdate);
        if (rafId) cancelAnimationFrame(rafId);
      });
    }

    const scrollKnop = root.querySelector('[data-cs-scroll-keuzeblok]');
    const keuzeblok = root.querySelector('[data-cs-keuzeblok]');
    if (scrollKnop && keuzeblok) {
      scrollKnop.addEventListener('click', () => {
        keuzeblok.scrollIntoView({
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
          block: 'start',
        });
      });
    }

    root.csTeardown = () => {
      teardowns.forEach((fn) => fn());
      delete root.dataset.csInit;
    };
  };

  document.querySelectorAll('.section-cs-pdp-hero').forEach(initPdp);

  /* Theme editor rendert secties opnieuw zonder page load. */
  document.addEventListener('shopify:section:load', (event) => initPdp(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-cs-pdp]');
    if (root && root.csTeardown) root.csTeardown();
  });

  /* Theme editor: blok geselecteerd in de zijbalk = bijbehorende staat tonen,
     anders is de wijziging voor de merchant onzichtbaar (uitklap/carrousel). */
  document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof Element)) return;
    const pakket = event.target.closest('[data-cs-pakket]');
    const root = event.target.closest('[data-cs-pdp]');
    if (!root) return;
    if (pakket) {
      const radio = pakket.querySelector('.cs-pakket__radio');
      if (radio) radio.checked = true;
      if (root.csKiesPakket) root.csKiesPakket(pakket);
      return;
    }
    if (event.target.hasAttribute('data-cs-review') && root.csSelecteerReview) {
      root.csSelecteerReview(event.target);
    }
  });
})();
